export enum FileTypeName {
  Unknown = 'Unknown',
  AdditionalDocument = 'AdditionalDocument',
  AdditionalInformation = 'AdditionalInformation',
  ApplicationStandardAgreement_Finance = 'ApplicationStandardAgreement_Finance',
  IncomeSource = 'IncomeSource',
  IncomeSourceConfirmation_Global = 'IncomeSourceConfirmation_Global',
  OpenSubAccountOrder = 'OpenSubAccountOrder',
  ProofOfResidence = 'ProofOfResidence',
  Selfie = 'Selfie',
  SignaturesCard = 'SignaturesCard',
  SignedApplicationStandardAgreement_Finance = 'SignedApplicationStandardAgreement_Finance',
  SignedOpenSubAccountOrder_Finance = 'SignedOpenSubAccountOrder_Finance',
  TaxResidence = 'TaxResidence',
  ClientServiceAgreement = 'ClientServiceAgreement',
  ClientServiceAgreement_Global = 'ClientServiceAgreement_Global',
  W8BENForm = 'W8BENForm',
  WithdrawalAccountOwnerConfirmation = 'WithdrawalAccountOwnerConfirmation',
  Questionnaire = 'Questionnaire',
  SignedQuestionnaire = 'SignedQuestionnaire',
  ClientSignedClientServiceAgreement = 'ClientSignedClientServiceAgreement',
  CompanySignedAgreement_Finance = 'CompanySignedAgreement_Finance',
  CompanySignedClientServiceAgreement_Global = 'CompanySignedClientServiceAgreement_Global',
  CompanySignedClientServiceAgreement = 'CompanySignedClientServiceAgreement',
  IdentityDocument = 'IdentityDocument',
  CompanySignedNoticeOfInvestmentAccountOpening = 'CompanySignedNoticeOfInvestmentAccountOpening',
  ConstitutionalDocument = 'ConstitutionalDocument',
  FullySignedClientServiceAgreement_Global = 'FullySignedClientServiceAgreement_Global',
  FullySignedClientServiceAgreement = 'FullySignedClientServiceAgreement',
  IncomeSourcesConfirmation = 'IncomeSourcesConfirmation',
  LastYearAuditFinancialReport = 'LastYearAuditFinancialReport',
  LegalAddressConfirmation = 'LegalAddressConfirmation',
  License = 'License',
  OwnershipStructure = 'OwnershipStructure',
  RecommendationLetter = 'RecommendationLetter',
  StateRegistrationConfirmation = 'StateRegistrationConfirmation',
  UnidentifiableBeneficiaryLetter = 'UnidentifiableBeneficiaryLetter',
  OpenAccountOrder_Finance = 'OpenAccountOrder_Finance',
  ServiceContract_Finance = 'ServiceContract_Finance',
}
export interface FileEntity {
  id: string;
  name: string;
  size: number;
  type: FileTypeName;
  createdAt: Date;
}
